import "./About.css";

function About() {
  return (
    <>
      <section id="about" className="homepage-section">
        <h1 className="about-title">About Me</h1>
        <div className="about-container">
          <div className="about-details-container">
            <div className="text-container">
              <p>
                Hello, I am a graduate student at Youngstown State University,
                holding a B.Sc. in Information Technology with a specialization
                in Application Development.
              </p>
              <p>
                During my college education, I explored various interests,
                including the medical profession due to my initial curiosity
                about human health and longevity. However, as I gained
                knowledge, I discovered a passion for technology and its
                potential to drive innovation and problem-solving. My goal now
                is to contribute meaningfully to the tech industry, leveraging
                my skills in programming, frameworks, and methodologies.
              </p>
              <p>
                Drawing from my academic background and professional experience,
                I am proficient in a wide range of programming languages,
                frameworks, and methodologies. This specific information can be
                found under the “View Resume” or “Experience” section. Committed
                to staying at the forefront of technological advancements, I
                actively pursue continuous knowledge to expand my horizon.
              </p>
              <p>
                Beyond coding, I find joy in taking walks in the park,
                appreciating the wonders of nature, exploring different
                cuisines, and playing video games whenever I have free time.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default About;
